import React from 'react';
import type { Theme } from '@material-ui/core';

import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { getEnvironment } from '@klp/helpers';

import { Block } from '../Block';

const environment = getEnvironment();

const indicatorBoxWidth = 80;
const styles = (theme: Theme) => ({
    root: {
        position: 'fixed',
        top: '0px',
        right: -indicatorBoxWidth / Math.sqrt(2),
        zIndex: 10000,
        backgroundColor: '#FFC946',
        boxShadow: `0 0 1px ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        width: indicatorBoxWidth,
        height: indicatorBoxWidth,
        fontSize: indicatorBoxWidth / 6,
        fontWeight: 700,
        display: 'flex',
        paddingBottom: '0.25em',
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: 'center',
        transform: 'rotateZ(45deg)',
        transformOrigin: 'right top',
    },
});

export const EnvironmentIndicator = () => {
    const classes = useKlpStyles({}, styles);
    if (!environment) {
        return null;
    }

    return (
        <Block
            className={classes.root}
            translation={`environment.${environment}`}
        />
    );
};
